(() => {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-cl-card-swatch]');
    if (!button) return;
    const card = button.closest('[data-cl-card]');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    const group = button.closest('.cl-card-colours');
    const data = { ...button.dataset };
    data.image = window.CLStudio?.url(data.image) || data.image;
    data.srcset = window.CLStudio?.srcset(data.srcset) || data.srcset;
    group.querySelectorAll('[data-cl-card-swatch]').forEach((swatch) => {
      swatch.setAttribute('aria-pressed', String(swatch === button));
    });
    card.dataset.selectedVariant = data.variantId;
    card.querySelectorAll('img[data-cl-front-selected]').forEach(image => delete image.dataset.clFrontSelected);
    const productPath = new URL(data.productUrl, location.origin).pathname;
    card.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, location.origin);
      if (url.pathname !== productPath) return;
      url.searchParams.set('variant', data.variantId);
      link.href = url.toString();
    });
    if (typeof card.applyVariantToLinks === 'function') card.applyVariantToLinks(data.variantId);
    const name = card.querySelector('[data-cl-card-name]');
    if (name) {
      const description = name.querySelector('[data-cl-base-descriptor]');
      if (description) description.textContent = [description.dataset.clBaseDescriptor, 'in ' + data.colour].filter(Boolean).join(' ');
      else name.textContent = card.dataset.productTitle + ' in ' + data.colour;
    }
    const prices = card.querySelectorAll('[data-cl-card-price], product-price [ref="priceContainer"]');
    prices.forEach((price) => {
      price.textContent = data.price;
      if (data.compare) {
        const compare = document.createElement('s');
        compare.textContent = data.compare;
        price.append(compare);
      }
    });
    const available = data.available === 'true';
    const status = card.querySelector('[data-cl-card-status]');
    if (status) { status.hidden = available; status.textContent = available ? '' : 'Sold out'; }
    card.querySelectorAll('[data-clo-qa]').forEach((quickAdd) => {
      quickAdd.dataset.cloVariant = data.variantId;
      quickAdd.disabled = !available;
      if (data.image) {
        quickAdd.dataset.cloImg = data.image;
        quickAdd.dataset.cloColour = data.colour;
      } else {
        delete quickAdd.dataset.cloImg;
        delete quickAdd.dataset.cloColour;
      }
    });
    if (window.CLPremiumGallery?.selectCard(card, data)) {
      card.dispatchEvent(new CustomEvent('cl:card-colour', { bubbles: true }));
      return;
    }
    card.toggleAttribute('data-cl-image-missing', !data.image);
    if (!data.image) { card.dispatchEvent(new CustomEvent('cl:card-colour', { bubbles: true })); return; }
    const nativeSlide = card.querySelector(`slideshow-slide[slide-id="${data.mediaId}"]`);
    if (nativeSlide && typeof card.previewVariant === 'function') {
      card.previewVariant(data.mediaId);
      card.setAttribute('data-featured-media-url', data.image);
    } else {
      const image = card.querySelector('.clo-pc__ph img, slideshow-slide[aria-hidden="false"] img, .card-gallery img');
      if (image) {
        image.srcset = data.srcset || '';
        image.src = data.image;
        image.alt = card.dataset.productTitle + ' in ' + data.colour;
      }
      if (card.matches('product-card')) card.setAttribute('data-featured-media-url', data.image);
    }
    card.dispatchEvent(new CustomEvent('cl:card-colour', { bubbles: true }));
  }, true);
})();


(() => {
  const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  const states = new WeakMap();
  const normal = value => String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();

  function imageInfo(image) {
    const match = String(image?.alt || '').match(/^(.*),\s*image\s+(\d+)\b/i);
    if (!match) return null;
    const separator = match[1].toLowerCase().lastIndexOf(' in ');
    if (separator < 0) return null;
    return { colour: normal(match[1].slice(separator + 4)), number: Number(match[2]) };
  }

  function imagePair(data, colour, variantId) {
    const images = Array.isArray(data.images) ? data.images : [];
    const wanted = normal(colour || data.initialColour);
    const empty = { primary: null, secondary: null };
    if (!wanted) return empty;
    const matching = images.filter(image => imageInfo(image)?.colour === wanted);
    const variants = data.variantImages || [];
    const variant = variants.find(item => String(item.id) === String(variantId || data.initialVariant));
    const anchor = matching.find(image => String(image.id) === String(variant?.imageId));
    const primary = data.hasMultipleFormats
      ? anchor
      : matching.find(image => imageInfo(image)?.number === 1) || anchor;
    if (!primary) return empty;
    if (imageInfo(primary)?.number !== 1) return { primary, secondary: null };
    const secondary = matching.find(image => {
      if (image === primary || imageInfo(image)?.number !== 2) return false;
      return !data.hasMultipleFormats || !variants.some(item =>
        String(item.imageId) === String(image.id) && String(item.imageId) !== String(primary.id));
    }) || null;
    return { primary, secondary };
  }

  window.CLCardImages = { pair: imagePair };

  function selectImage(data, primary, card) {
    if (!primary) return null;
    const swatch = card.querySelector('[data-cl-card-swatch][aria-pressed="true"]');
    return imagePair(data, swatch?.dataset.colour, card.dataset.selectedVariant || swatch?.dataset.variantId).secondary;
  }

  function stateFor(layer) {
    if (states.has(layer)) return states.get(layer);
    try {
      const state = { data: (window.CLStudio?.decorate || (data => data))(JSON.parse(layer.querySelector('[data-cl-hover-data]').textContent)), token: 0, hovered: false, candidate: null, image: null };
      states.set(layer, state);
      return state;
    } catch { return null; }
  }

  function primaryFor(mount) {
    return mount.querySelector('[data-cl-hover-primary]')
      || mount.querySelector('slideshow-slide[aria-hidden="false"] img')
      || mount.querySelector('slideshow-slide:not([hidden]) img')
      || mount.querySelector('img:not(.cl-card-hover img)');
  }

  function update(card, hovered) {
    if (card.querySelector('[data-cl-premium]')) return;
    const layer = card.querySelector('[data-cl-hover]');
    if (!layer) return;
    const state = stateFor(layer);
    if (!state) return;
    const mount = layer.parentElement;
    state.hovered = hovered;
    if (!desktop.matches || !hovered || card.hasAttribute('data-cl-image-missing')) {
      mount.classList.remove('cl-card-hover--active');
      return;
    }
    const primary = primaryFor(mount);
    const candidate = selectImage(state.data, primary, card);
    if (!candidate) {
      state.token += 1;
      state.candidate = null;
      mount.classList.remove('cl-card-hover--active');
      return;
    }
    primary.classList.add('cl-card-hover__primary');
    if (state.candidate === candidate && state.image?.complete && state.image.naturalWidth > 0) {
      mount.classList.add('cl-card-hover--active');
      return;
    }
    mount.classList.remove('cl-card-hover--active');
    state.candidate = candidate;
    state.image = null;
    const token = ++state.token;
    const image = new Image();
    const primaryStyle = getComputedStyle(primary);
    image.alt = '';
    image.dataset.clHoverSecondary = '';
    image.decoding = 'async';
    image.width = candidate.width;
    image.height = candidate.height;
    image.style.objectFit = primaryStyle.objectFit;
    image.style.objectPosition = primaryStyle.objectPosition;
    image.style.mixBlendMode = primaryStyle.mixBlendMode;
    image.sizes = primary.sizes || layer.dataset.sizes;
    image.onload = async () => {
      if (token !== state.token || !layer.isConnected) return;
      if (window.CLCardPresentation) await window.CLCardPresentation.prepare(image, mount, card, candidate.alt);
      if (token !== state.token || !layer.isConnected) return;
      layer.querySelector('img')?.remove();
      layer.append(image);
      state.image = image;
      if (desktop.matches && state.hovered) mount.classList.add('cl-card-hover--active');
    };
    image.onerror = () => {
      if (token === state.token) mount.classList.remove('cl-card-hover--active');
    };
    image.srcset = candidate.srcset || [...new Set([360, 540, 720, 1000, 1400, 2000].filter(width => width < Math.min(2000, candidate.width || 2000)).concat(Math.min(2000, candidate.width || 2000)))].map((width) => { const url = new URL(candidate.url, location.origin); url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', ');
    image.src = candidate.url;
  }

  const cardFor = (target) => target instanceof Element ? target.closest('[data-cl-hover-card], [data-cl-card]') : null;
  const swatchSelector = '.cl-card-colours, [data-cl-card-swatch], [data-cl-card-more], swatches-variant-picker-component, .variant-option--swatches';
  let activeCard = null;

  function setActiveCard(card) {
    if (card === activeCard) return;
    if (activeCard) update(activeCard, false);
    activeCard = card;
    if (card) update(card, true);
  }

  function photoCardAt(target, event) {
    if (!(target instanceof Element) || target.closest(swatchSelector)) return null;
    const card = cardFor(target);
    const mount = card?.querySelector('[data-cl-hover]')?.parentElement;
    if (!mount?.matches('[data-cl-hover-media]')) return null;
    // Some native cards use a sibling link over the media: check the photo's
    // actual bounds, so the title and colour controls never trigger its hover.
    const rect = mount.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX < rect.right
      && event.clientY >= rect.top && event.clientY < rect.bottom ? card : null;
  }

  function trackPhoto(event) {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    setActiveCard(photoCardAt(event.target, event));
  }

  document.addEventListener('pointerover', trackPhoto);
  document.addEventListener('pointermove', trackPhoto);
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    setActiveCard(desktop.matches ? photoCardAt(event.relatedTarget, event) : null);
  });
  document.addEventListener('pointercancel', () => setActiveCard(null));
  window.addEventListener('blur', () => setActiveCard(null));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) setActiveCard(null);
  });
  document.addEventListener('cl:card-colour', (event) => {
    const card = cardFor(event.target);
    if (!card) return;
    if (activeCard === card) setActiveCard(null);
    else update(card, false);
  });
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest(swatchSelector)
      && cardFor(event.target) === activeCard) setActiveCard(null);
  }, true);
  desktop.addEventListener('change', () => setActiveCard(null));
})();

(() => {
  if (window.CLCardPresentation) return;
  const mediaSelector = '.clo-pc__ph, .card-gallery, .image-block, .resource-card__media, .clo-pair__media';
  const groupSelector = '.clo-rail, .clo-cgrid, .product-grid, .resource-list__carousel, .resource-list, .clo-pair, .clo-edgrid';
  const titleSelector = '.clo-pc__nm, [ref="productTitleLink"], .resource-card__title, .clo-pair__title';
  const seen = new WeakSet();
  const jobs = new Map();
  const tokens = new WeakMap();
  const metadata = new WeakMap();
  const widths = new WeakMap();
  const pending = [];
  const collectionProfiles = new Map();
  let active = 0;
  let alignmentTask = 0;

  function identity(src) {
    try {
      const url = new URL(src, location.origin);
      ['width', 'height', 'crop', 'format'].forEach((key) => url.searchParams.delete(key));
      return url.href;
    } catch { return src; }
  }

  function editorial(alt, source = '') {
    if (/\bimage (5|7)\b/i.test(alt || '') && /\.png(?:\?|$)/i.test(source)) return true;
    return /\b(worn|model|mannequin|lifestyle|wearing|carried|held|on shoulder|on body)\b/i.test(alt || '');
  }

  function geometry(box, aspect, large = false, frameRatio = 1) {
    if (!box || box.edge) {
      const width = Math.min(1, frameRatio * aspect);
      const height = width / aspect / frameRatio;
      return { width, height, left: (1 - width) / 2, top: (1 - height) / 2, mode: box?.edge ? 'source-edge' : 'preserved' };
    }
    const spanX = box.right - box.left;
    const spanY = (box.bottom - box.top) / aspect;
    const target = large ? .88 : .84;
    const width = Math.min(target / Math.max(spanX, spanY), .94 / spanX, frameRatio * .94 / spanY);
    const height = width / aspect / frameRatio;
    return { width, height, left: .5 - (box.left + box.right) / 2 * width, top: .5 - (box.top + box.bottom) / 2 * height, mode: 'normalized' };
  }

  function measure(pixels, w, h) {
    const corners = [];
    let transparent = 0;
    for (let i = 3; i < pixels.length; i += 4) if (pixels[i] < 240) transparent++;
    const alphaImage = transparent > w * h * .12;
    for (const [cx, cy] of [[0, 0], [w - 4, 0], [0, h - 4], [w - 4, h - 4]]) {
      for (let y = cy; y < cy + 4; y++) for (let x = cx; x < cx + 4; x++) {
        const i = (y * w + x) * 4;
        corners.push([pixels[i], pixels[i + 1], pixels[i + 2]]);
      }
    }
    const bg = [0, 1, 2].map((channel) => corners.map((p) => p[channel]).sort((a, b) => a - b)[32]);
    if (!alphaImage && (Math.min(...bg) < 205 || corners.some((p) => p.some((v, i) => Math.abs(v - bg[i]) > 24)))) return null;
    const mask = new Uint8Array(w * h);
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const difference = Math.max(Math.abs(pixels[i] - bg[0]), Math.abs(pixels[i + 1] - bg[1]), Math.abs(pixels[i + 2] - bg[2]));
      mask[y * w + x] = alphaImage ? Number(pixels[i + 3] > 100) : Number(difference > 22);
    }
    let left = w, top = h, right = 0, bottom = 0, count = 0;
    const queue = new Int32Array(w * h);
    for (let start = 0; start < mask.length; start++) {
      if (mask[start] !== 1) continue;
      let head = 0, tail = 1;
      queue[0] = start; mask[start] = 2;
      let l = w, t = h, r = 0, b = 0;
      while (head < tail) {
        const point = queue[head++], x = point % w, y = Math.floor(point / w);
        l = Math.min(l, x); t = Math.min(t, y); r = Math.max(r, x + 1); b = Math.max(b, y + 1);
        for (const next of [x > 0 ? point - 1 : -1, x + 1 < w ? point + 1 : -1, y > 0 ? point - w : -1, y + 1 < h ? point + w : -1]) {
          if (next >= 0 && mask[next] === 1) { mask[next] = 2; queue[tail++] = next; }
        }
      }
      if (tail < 3) continue;
      count += tail; left = Math.min(left, l); top = Math.min(top, t); right = Math.max(right, r); bottom = Math.max(bottom, b);
    }
    if (count < w * h * .008 || count > w * h * .8 || right <= left || bottom <= top) return null;
    const edge = left < 2 || top < 2 || right > w - 2 || bottom > h - 2;
    return { left: Math.max(0, left - 2) / w, top: Math.max(0, top - 2) / h, right: Math.min(w, right + 2) / w, bottom: Math.min(h, bottom + 2) / h, edge, transparent: alphaImage };
  }

  function backgroundMask(pixels, w, h, box) {
    const cornerPoints = [0, w - 1, (h - 1) * w, w * h - 1];
    const bg = [0, 1, 2].map(c => Math.round(cornerPoints.reduce((sum, n) => sum + pixels[n * 4 + c], 0) / 4));
    if (Math.min(...bg) < 205 || cornerPoints.some(n => pixels[n * 4 + 3] < 240 || bg.some((v, c) => Math.abs(pixels[n * 4 + c] - v) > 8))) return null;
    const removed = new Uint8Array(w * h), queue = new Int32Array(w * h);
    let head = 0, tail = 0;
    const enqueue = n => {
      if (n < 0 || removed[n]) return;
      const i = n * 4;
      if (pixels[i + 3] < 240 || bg.some((v, c) => Math.abs(pixels[i + c] - v) > 10)) return;
      removed[n] = 1; queue[tail++] = n;
    };
    for (let x = 0; x < w; x++) { enqueue(x); enqueue((h - 1) * w + x); }
    for (let y = 0; y < h; y++) { enqueue(y * w); enqueue(y * w + w - 1); }
    while (head < tail) {
      const n = queue[head++], x = n % w, y = Math.floor(n / w);
      if (x) enqueue(n - 1); if (x + 1 < w) enqueue(n + 1);
      if (y) enqueue(n - w); if (y + 1 < h) enqueue(n + w);
    }
    if (tail < w * h * .15 || tail > w * h * .94) return null;
    if (box) {
      const l = Math.floor((box.left + (box.right - box.left) * .3) * w), r = Math.ceil((box.right - (box.right - box.left) * .3) * w);
      const t = Math.floor((box.top + (box.bottom - box.top) * .55) * h), b = Math.ceil((box.top + (box.bottom - box.top) * .85) * h);
      let central = 0, erased = 0;
      for (let y = t; y < b; y++) for (let x = l; x < r; x++) { central++; erased += removed[y * w + x]; }
      if (central && erased / central > .15) return null;
    }
    return removed;
  }

  function frontImage(data, current, colour, variantId) {
    return window.CLCardImages.pair(data, colour, variantId).primary;
  }

  function drain() {
    while (active < 3 && pending.length) {
      active++;
      const task = pending.shift();
      task().finally(() => { active--; drain(); });
    }
  }

  function analyze(src) {
    const key = identity(src);
    if (jobs.has(key)) return jobs.get(key);
    const promise = new Promise((resolve) => {
      pending.push(async () => {
        const result = await new Promise((done) => {
          const sample = new Image();
          sample.crossOrigin = 'anonymous';
          const timeout = setTimeout(() => done(null), 4500);
          sample.onload = () => {
            clearTimeout(timeout);
            try {
              const ratio = sample.naturalWidth / sample.naturalHeight;
              const w = Math.round(1000 * Math.min(1, ratio)), h = Math.round(1000 * Math.min(1, 1 / ratio));
              const canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
              const context = canvas.getContext('2d', { willReadFrequently: true });
              context.drawImage(sample, 0, 0, w, h);
              const pixels = context.getImageData(0, 0, w, h).data;
              const smallW = Math.max(4, Math.round(w / 5)), smallH = Math.max(4, Math.round(h / 5));
              const small = document.createElement('canvas'); small.width = smallW; small.height = smallH;
              const smallContext = small.getContext('2d', { willReadFrequently: true });
              smallContext.drawImage(sample, 0, 0, smallW, smallH);
              const box = measure(smallContext.getImageData(0, 0, smallW, smallH).data, smallW, smallH);
              const removed = box ? backgroundMask(pixels, w, h, box) : null;
              if (removed) {
                const maskCanvas = document.createElement('canvas'); maskCanvas.width = w; maskCanvas.height = h;
                const maskContext = maskCanvas.getContext('2d');
                const maskPixels = maskContext.createImageData(w, h);
                for (let n = 0; n < removed.length; n++) {
                  maskPixels.data[n * 4] = maskPixels.data[n * 4 + 1] = maskPixels.data[n * 4 + 2] = 255;
                  maskPixels.data[n * 4 + 3] = removed[n] ? 0 : 255;
                }
                maskContext.putImageData(maskPixels, 0, 0);
                box.mask = maskCanvas.toDataURL('image/png');
              }
              done(box);
            } catch { done(null); }
          };
          sample.onerror = () => { clearTimeout(timeout); done(null); };
          const url = new URL(src, location.origin); url.searchParams.set('width', '1000');
          sample.src = url.href;
        });
        resolve(result);
      });
      drain();
    });
    jobs.set(key, promise);
    if (jobs.size > 60) jobs.delete(jobs.keys().next().value);
    return promise;
  }

  function imageMetadata(card, image) {
    if (!metadata.has(card)) {
      try { metadata.set(card, (window.CLStudio?.decorate || (data => data))(JSON.parse(card.querySelector('[data-cl-hover-data]')?.textContent || '{}'))); }
      catch { metadata.set(card, {}); }
    }
    const path = new URL(image.currentSrc || image.src, location.origin).pathname;
    return metadata.get(card).images?.find((item) => new URL(item.url, location.origin).pathname === path);
  }

  function apply(image, frame, result) {
    const card = frame.closest('[data-cl-frame]');
    const compactProduct = !card?.closest('[data-cl-collection-ux]') && ['15836178776441', '15836161802617'].includes(card?.dataset.clFrameProductId);
    const alt = card ? imageMetadata(card, image)?.alt || image.alt : image.alt;
    if (compactProduct && !editorial(alt, image.currentSrc || image.src) && !/\b(detail|interior|inside|compartment|close up)\b/i.test(alt)) {
      const scale = 0.72;
      result = { ...result, width: result.width * scale, height: result.height * scale, left: 0.5 + (result.left - 0.5) * scale, top: 0.5 + (result.top - 0.5) * scale };
    }
    image.classList.add('cl-card-framed-image');
    for (const name of ['width', 'height', 'left', 'top']) image.style.setProperty('--cl-image-' + name, (result[name] * 100).toFixed(4) + '%');
    image.dataset.clFraming = result.mode;
    const renderedWidth = frame.getBoundingClientRect().width * result.width;
    if (renderedWidth > 0 && image.srcset) image.sizes = Math.ceil(renderedWidth) + 'px';
  }

  async function collectionGeometry(image, card, aspect) {
    const section = card.closest('[data-cl-collection-ux]');
    const url = section.dataset.clPresentationUrl;
    const original = geometry(null, aspect);
    if (!url) return original;
    // Offline envelopes avoid canvas work and extra image requests on shoppers' devices.
    // Unknown photographs retain their complete original contain framing.
    if (!collectionProfiles.has(url)) {
      collectionProfiles.set(url, fetch(url).then(response => response.ok ? response.json() : {}).catch(() => ({})));
    }
    const profiles = await collectionProfiles.get(url);
    const filename = decodeURIComponent(new URL(image.currentSrc || image.src, location.origin).pathname.split('/').pop());
    const bounds = profiles[filename];
    if (!Array.isArray(bounds) || bounds.length !== 4 || !bounds.every(Number.isFinite)) return original;
    const [left, top, right, bottom] = bounds;
    if (left < 0 || top < 0 || right > 1 || bottom > 1 || right <= left || bottom <= top) return original;
    const target = { compact: .52, small_goods: .50, beauty: .58, tote: .64, large: .68, accessory: .60 }[card.dataset.clVisualFamily] || .60;
    const span = Math.max(right - left, (bottom - top) / aspect);
    if (left < .02 || top < .02 || right > .98 || bottom > .98) {
      // Source-edge content can only become smaller: never introduce a new crop.
      const scale = Math.min(1, target / (span * original.width));
      const width = original.width * scale, height = original.height * scale;
      return { width, height, left: (1 - width) / 2, top: (1 - height) / 2, mode: 'collection-source-edge' };
    }
    const width = Math.min(1.12, target / span);
    const height = width / aspect;
    return { width, height, left: .5 - (left + right) / 2 * width, top: .5 - (top + bottom) / 2 * height, mode: 'collection-envelope' };
  }

  async function prepare(image, frame, card, alt) {
    if (!image.naturalWidth || !image.naturalHeight) return;
    const cardData = metadata.get(card) || (() => {
      try { const data = (window.CLStudio?.decorate || (data => data))(JSON.parse(card.querySelector('[data-cl-hover-data]')?.textContent || '{}')); metadata.set(card, data); return data; } catch { return {}; }
    })();
    const isPrimary = !image.hasAttribute('data-cl-gallery-image') && !image.hasAttribute('data-cl-hover-secondary') && (image.hasAttribute('data-cl-hover-primary') || (!image.closest('[data-cl-hover]') && !image.closest('slideshow-slide[aria-hidden="true"]')));
    if (isPrimary && !image.dataset.clFrontSelected) {
      const current = imageMetadata(card, image);
      const selectedColour = card.querySelector('[data-cl-card-swatch][aria-pressed="true"]')?.dataset.colour;
      const candidate = frontImage(cardData, current, selectedColour, card.dataset.selectedVariant);
      image.dataset.clFrontSelected = 'true';
      if (candidate && identity(candidate.url) !== identity(image.currentSrc || image.src)) {
        const source = new URL(candidate.url, location.origin);
        source.searchParams.set('width', String(Math.min(2000, candidate.width || 2000)));
        const widths = [...new Set([360, 540, 720, 1000, 1400, 2000].filter(width => width < Math.min(2000, candidate.width || 2000)).concat(Math.min(2000, candidate.width || 2000)))];
        image.srcset = widths.map(width => { const url = new URL(source); url.searchParams.set('width', String(width)); return url.href + ' ' + width + 'w'; }).join(', ');
        image.src = source.href;
        image.alt = (candidate.alt || cardData.title || image.alt).replace(/Ashford/g, 'Emma');
        return;
      }
    }
    const src = image.currentSrc || image.src;
    const token = {};
    tokens.set(image, token);
    const info = imageMetadata(card, image);
    const text = alt || info?.alt || image.alt;
    const aspect = image.naturalWidth / image.naturalHeight;
    const frameRatio = 1;
    image.style.removeProperty('mask-image'); image.style.removeProperty('-webkit-mask-image');
    if (/\/cl-v20261027-15836163178873-(?:64759456366969|64759456399737)-(?:front|3quarts|dos)-/.test(new URL(src, location.origin).pathname)) {
      apply(image, frame, geometry(null, aspect, false, frameRatio));
      image.classList.add('cl-studio-normalized');
      image.dataset.clFraming = 'studio-file';
      image.dataset.clBackground = 'preserved';
      return;
    }
    if (card.closest('[data-cl-collection-ux]')) {
      const result = await collectionGeometry(image, card, aspect);
      if (tokens.get(image) !== token || identity(image.currentSrc || image.src) !== identity(src)) return;
      apply(image, frame, result);
      image.dataset.clBackground = 'preserved';
      if (window.CLStudio?.isNormalized(src)) image.classList.add('cl-studio-normalized');
      return;
    }
    if (window.CLStudio?.isNormalized(src)) { apply(image, frame, geometry(null, aspect, false, frameRatio)); image.classList.add('cl-studio-normalized'); image.dataset.clFraming = 'studio-file'; return; }
    if (editorial(text, image.currentSrc || image.src) || /\b(detail|interior|inside|compartment|close up)\b/i.test(text)) { apply(image, frame, geometry(null, aspect, false, frameRatio)); image.dataset.clFraming = 'editorial'; return; }
    const box = await analyze(src);
    if (tokens.get(image) !== token || identity(image.currentSrc || image.src) !== identity(src)) return;
    const paleProduct = /\bin (white|ivory|cream|ecru|off white|pale grey)\b/i.test(text);
    if (box?.mask && !paleProduct) {
      image.style.setProperty('mask-image', 'url("' + box.mask + '")');
      image.style.setProperty('-webkit-mask-image', 'url("' + box.mask + '")');
      image.dataset.clBackground = 'masked';
    } else { image.dataset.clBackground = 'preserved'; }
    apply(image, frame, geometry((box?.mask && !paleProduct) || box?.transparent ? box : null, aspect, card.dataset.clFrame === 'large', frameRatio));
  }

  function setProperty(element, key, value) {
    if (element.style.getPropertyValue(key) !== value) element.style.setProperty(key, value);
  }

  function align() {
    alignmentTask = 0;
    const groups = new Map();
    document.querySelectorAll('[data-cl-frame]').forEach((card) => {
      if (card.closest('[data-cl-collection-ux]')) return;
      if (!card.getBoundingClientRect().width) return;
      const group = card.closest(groupSelector) || card.parentElement;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(card);
    });
    groups.forEach((cards) => {
      for (const key of ['--cl-card-title-height', '--cl-card-model-height', '--cl-card-descriptor-height']) cards.forEach((card) => card.style.removeProperty(key));
      for (const [selector, key] of [['.cl-product-name__model', '--cl-card-model-height'], ['.cl-product-name__descriptor', '--cl-card-descriptor-height'], [titleSelector, '--cl-card-title-height']]) {
        const elements = cards.map((card) => card.querySelector(selector)).filter(Boolean);
        const height = Math.max(0, ...elements.map((element) => element.getBoundingClientRect().height));
        if (height) cards.forEach((card) => setProperty(card, key, Math.ceil(height) + 'px'));
      }
    });
  }

  function scheduleAlignment() {
    if (!alignmentTask) alignmentTask = requestAnimationFrame(align);
  }

  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      if (widths.get(target) === contentRect.width) return;
      widths.set(target, contentRect.width);
      target.querySelectorAll('img.cl-card-framed-image').forEach((image) => {
        const width = parseFloat(image.style.getPropertyValue('--cl-image-width')) / 100;
        if (image.srcset && contentRect.width > 0) image.sizes = Math.ceil(contentRect.width * width) + 'px';
      });
      scheduleAlignment();
    });
  }) : null;

  const visible = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      visible.unobserve(entry.target);
      entry.target.querySelectorAll('img:not(.cl-card-hover img)').forEach((image) => {
        const update = () => prepare(image, entry.target, entry.target.closest('[data-cl-frame]'));
        image.addEventListener('load', update);
        if (image.complete) update();
      });
    });
  }, { rootMargin: '300px' }) : null;

  function scan() {
    document.querySelectorAll('[data-cl-frame]').forEach((card) => {
      const frame = card.matches('.clo-tile, .clo-gal__th button') ? card : card.querySelector(mediaSelector);
      if (!frame) return;
      frame.dataset.clFrameMedia = '';
      const layer = card.querySelector('[data-cl-hover]');
      if (layer && !card.dataset.clVariantInitialised) {
        card.dataset.clVariantInitialised = 'true';
        try {
          const data = (window.CLStudio?.decorate || (data => data))(JSON.parse(layer.querySelector('[data-cl-hover-data]').textContent));
          const initial = data.variantImages?.find(v => String(v.id) === String(data.initialVariant));
          if (!initial?.imageId && !window.CLPremiumGallery) card.setAttribute('data-cl-image-missing', '');
          if (!card.dataset.selectedVariant && !data.initialExplicit) {
            const swatch = card.querySelector(`[data-cl-card-swatch][data-variant-id="${data.initialVariant}"]`);
            if (swatch) swatch.click();
          }
        } catch {}
      }
      if (layer && layer.parentElement !== frame && !frame.contains(layer)) {
        const mount = frame.matches('.clo-pc__ph') ? frame.querySelector('[data-cl-hover-media]') || frame : frame;
        mount.dataset.clHoverMedia = '';
        mount.append(layer);
      }
      if (!seen.has(frame)) {
        seen.add(frame);
        resize?.observe(frame);
        if (visible) visible.observe(frame);
        else frame.querySelectorAll('img').forEach((image) => {
          const update = () => prepare(image, frame, card);
          image.addEventListener('load', update); if (image.complete) update();
        });
      }
    });
    document.querySelectorAll('.clo-rail-sec, .section-resource-list').forEach((section) => {
      const link = [...section.querySelectorAll('a')].find((anchor) => /^view all$/i.test(anchor.textContent.replace(/\s+/g, ' ').trim()));
      if (!link || link.closest('.cl-card-view-all') || !section.querySelector('[data-cl-frame]')) return;
      const footer = document.createElement('div'); footer.className = 'cl-card-view-all';
      footer.append(link); section.append(footer);
    });
    scheduleAlignment();
  }

  window.CLCardPresentation = { prepare, geometry, measure, editorial, backgroundMask, frontImage };
  function start() {
    scan();
    new MutationObserver((entries) => {
      if (entries.some((entry) => entry.type === 'childList')) scan();
      entries.forEach((entry) => {
        if (entry.type !== 'attributes' || !(entry.target instanceof HTMLImageElement)) return;
        const image = entry.target, frame = image.closest('[data-cl-frame-media]'), card = image.closest('[data-cl-frame]');
        if (frame && card && image.complete) prepare(image, frame, card);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    document.addEventListener('cl:card-colour', scheduleAlignment);
    document.addEventListener('shopify:section:load', scan);
    document.fonts?.ready.then(scheduleAlignment);
    window.addEventListener('resize', scheduleAlignment, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

